import React from 'react';

interface Props {
  answer: string;
  selected: boolean;
  onClick: (answer: string) => void;
  disabled?: boolean;
}

const AnswerBox = React.memo(({answer, selected, onClick, disabled}: Props) => {
  return (
    <div
      role="checkbox"
      aria-checked={selected}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={() => !disabled && onClick(answer)}
      onKeyDown={event => {
        if (!disabled && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          onClick(answer);
        }
      }}
      className="AnswerBox">
      <div className="Checkbox">
        {selected ? <div className="Checked" /> : <div />}
      </div>
      <span>{answer}</span>
    </div>
  );
});

export default AnswerBox;
